(function () {
  'use strict';

  var SORT_MAP = {
    'popularity':  'best-selling',
    'price-asc':   'price-ascending',
    'price-desc':  'price-descending',
    'newest':      'created-descending'
  };

  var SORT_REVERSE = {
    'best-selling':        'popularity',
    'price-ascending':     'price-asc',
    'price-descending':    'price-desc',
    'created-descending':  'newest',
    'manual':              'popularity',
    '':                    'popularity'
  };

  var SORT_LABELS = {
    'popularity':  'Popularity',
    'price-asc':   'Price: Low to High',
    'price-desc':  'Price: High to Low',
    'newest':      'Newest'
  };

  document.querySelectorAll('.collection-page').forEach(function (wrapper) {
    var sid          = wrapper.dataset.sectionId;
    var sectionType  = wrapper.dataset.sectionType || 'tov-collection-grid';
    var RANGE_MAX    = parseInt(wrapper.dataset.priceMax, 10) || 3000;
    var params       = new URLSearchParams(window.location.search);

    /* ── In-memory filter state ── */
    var priceMin      = parseInt(params.get('filter.v.price.gte') || 0, 10);
    var priceMax      = parseInt(params.get('filter.v.price.lte') || RANGE_MAX, 10);
    var activeStock   = params.get('filter.v.availability') === '1' ? 'instock' : 'all';
    var shopifySortBy = params.get('sort_by') || wrapper.dataset.currentSort || '';
    var activeSortVal = SORT_REVERSE[shopifySortBy] || 'popularity';

    var grid           = document.getElementById('product-grid-' + sid);
    var loadMoreWrap   = document.getElementById('load-more-wrap-' + sid);
    var filterCountEl  = document.getElementById('filter-count-' + sid);
    var activeFiltersBar   = document.getElementById('active-filters-bar-' + sid);
    var activeFiltersChips = document.getElementById('active-filters-chips-' + sid);
    var activeFiltersReset = document.getElementById('active-filters-reset-' + sid);

    /* ── CLIENT-SIDE PRICE FILTER ─────────────────────────────────────────────
       Shopify ignores filter.v.price.* URL params without Search & Discovery.
       Price filtering is therefore done by showing/hiding cards in the DOM
       using data-price (Shopify stores prices in cents; slider uses Rs units).
       Sort and availability still use server-side AJAX (both work natively).
    ────────────────────────────────────────────────────────────────────────── */

    /* ── Price filter helpers ── */

    /* Return true if the product represented by this card has at least one
       variant whose price satisfies BOTH the min AND max bounds together.
       data-variant-prices is a comma-separated list of variant prices in
       Shopify cents, e.g. "42000,85000,135000".
       Fallback to data-price (min) / data-price-max when the attribute is
       absent (e.g. cards injected by the related-products JS). */
    function cardMatchesPrice(card, minCents, maxCents) {
      var raw = card.dataset.variantPrices;
      if (raw) {
        var prices = raw.split(',');
        for (var i = 0; i < prices.length; i++) {
          var p = parseInt(prices[i], 10);
          if (p >= minCents && p <= maxCents) return true;
        }
        return false;
      }
      /* Fallback: use price_min / price_max stored on the card.
         For a min-only filter: show if price_max >= minCents.
         For a max-only filter: show if price_min <= maxCents.
         For both: use the stored bounds (may over-include edge cases
         but never under-include a qualifying product). */
      var pMin = parseInt(card.dataset.price,    10) || 0;
      var pMax = parseInt(card.dataset.priceMax, 10) || pMin;
      return pMax >= minCents && pMin <= maxCents;
    }

    function applyPriceFilter() {
      if (!grid) return;
      var minCents = priceMin * 100;  /* slider Rs → Shopify cents */
      var maxCents = priceMax * 100;
      var visible  = 0;

      Array.from(grid.querySelectorAll('.product-card')).forEach(function (card) {
        var show = cardMatchesPrice(card, minCents, maxCents);
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });

      /* Update the filter count to reflect client-visible products */
      if (filterCountEl) {
        filterCountEl.textContent = visible + ' Items Found';
      }

      checkFilterActive();
      renderActiveFilters();
    }

    /* ── BUILD URL (for sort + stock AJAX only — price is client-side) ── */
    function buildUrl(opts) {
      var url     = new URL(window.location.pathname, window.location.origin);
      var sortVal = opts.sortVal !== undefined ? opts.sortVal  : activeSortVal;
      var stock   = opts.stock   !== undefined ? opts.stock    : activeStock;

      /* Preserve search query so /search?q=honey survives filter/sort changes */
      var searchQ = params.get('q');
      if (searchQ) url.searchParams.set('q', searchQ);

      url.searchParams.set('sort_by', SORT_MAP[sortVal] || 'best-selling');

      /* Price params stay in the URL so they survive page refresh/bookmark,
         but filtering is enforced client-side via applyPriceFilter(). */
      var pMin = opts.priceMin !== undefined ? opts.priceMin : priceMin;
      var pMax = opts.priceMax !== undefined ? opts.priceMax : priceMax;
      if (pMin > 0)         url.searchParams.set('filter.v.price.gte', pMin);
      if (pMax < RANGE_MAX) url.searchParams.set('filter.v.price.lte', pMax);

      if (stock === 'instock') url.searchParams.set('filter.v.availability', '1');

      return url.toString();
    }

    /* ── AJAX: swap grid for sort/stock changes ── */
    var isLoading = false;

    function applyFilters(targetUrl, stateUpdate) {
      if (isLoading) return;
      isLoading = true;

      if (stateUpdate) {
        if (stateUpdate.sortVal !== undefined) activeSortVal = stateUpdate.sortVal;
        if (stateUpdate.stock   !== undefined) activeStock   = stateUpdate.stock;
      }

      if (grid) grid.classList.add('is-loading');

      var sep      = targetUrl.indexOf('?') > -1 ? '&' : '?';
      var fetchUrl = targetUrl + sep + 'section_id=' + sid;

      fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var newGrid = doc.getElementById('product-grid-' + sid);
          if (newGrid && grid) grid.innerHTML = newGrid.innerHTML;

          /* Load-more update */
          var newLMBtn   = doc.getElementById('load-more-btn-' + sid);
          var newLMCount = doc.getElementById('load-more-count-' + sid);
          var myLMBtn    = document.getElementById('load-more-btn-' + sid);
          var myLMCount  = document.getElementById('load-more-count-' + sid);

          if (loadMoreWrap) {
            if (newLMBtn) {
              loadMoreWrap.classList.remove('hidden');
              if (myLMBtn) {
                myLMBtn.dataset.nextUrl = newLMBtn.dataset.nextUrl || '';
                myLMBtn.dataset.total   = newLMBtn.dataset.total   || '';
                myLMBtn.dataset.shown   = newLMBtn.dataset.shown   || '';
              }
              if (myLMCount && newLMCount) myLMCount.textContent = newLMCount.textContent;
            } else {
              loadMoreWrap.classList.add('hidden');
            }
          }

          history.pushState({}, '', targetUrl);

          /* After server swap, apply client-side price filter to new cards */
          applyPriceFilter();
          updateSortLabel();
          updateStockBtns();
        })
        .catch(function (err) {
          console.error('[TOV] Filter fetch failed:', err);
        })
        .finally(function () {
          if (grid) grid.classList.remove('is-loading');
          isLoading = false;
        });
    }

    /* ── Active filters bar ── */
    function renderActiveFilters() {
      if (!activeFiltersBar || !activeFiltersChips) return;

      var chips = [];
      if (priceMin > 0 && priceMax < RANGE_MAX) {
        chips.push('Rs ' + priceMin + ' – Rs ' + priceMax);
      } else if (priceMin > 0) {
        chips.push('Rs ' + priceMin + '+');
      } else if (priceMax < RANGE_MAX) {
        chips.push('Up to Rs ' + priceMax);
      }
      if (activeStock === 'instock') chips.push('In Stock');

      if (chips.length > 0) {
        activeFiltersChips.innerHTML = chips.map(function (label) {
          return '<span class="active-filter-chip">' + label + '</span>';
        }).join('');
        activeFiltersBar.style.display = 'flex';
      } else {
        activeFiltersChips.innerHTML = '';
        activeFiltersBar.style.display = 'none';
      }
    }

    if (activeFiltersReset) {
      activeFiltersReset.addEventListener('click', function () {
        priceMin   = 0;
        priceMax   = RANGE_MAX;
        activeStock = 'all';
        history.pushState({}, '', buildUrl({}));
        syncSlidersToState();
        applyPriceFilter();
        /* Also re-fetch to clear stock filter if it was active */
        applyFilters(buildUrl({}), {});
      });
    }

    /* ── Filter active indicator (mobile btn dot) ── */
    function checkFilterActive() {
      var active = priceMin > 0 || priceMax < RANGE_MAX || activeStock !== 'all';
      var btn = document.getElementById('mobile-filter-btn-' + sid);
      if (btn) btn.classList.toggle('has-filter', active);
    }

    /* ── Dual range slider ── */
    var priceDrop    = document.getElementById('price-dropdown-' + sid);
    var priceTrigger = document.getElementById('price-trigger-' + sid);
    var rangeMin     = document.getElementById('range-min-' + sid);
    var rangeMax_el  = document.getElementById('range-max-' + sid);
    var fill         = document.getElementById('range-fill-' + sid);
    var inputMin     = document.getElementById('input-min-' + sid);
    var inputMax     = document.getElementById('input-max-' + sid);

    /* Mobile slider refs (declared before syncSlidersToState) */
    var rMinM = document.getElementById('range-min-m-' + sid);
    var rMaxM = document.getElementById('range-max-m-' + sid);
    var fillM = document.getElementById('range-fill-m-' + sid);
    var iMinM = document.getElementById('input-min-m-' + sid);
    var iMaxM = document.getElementById('input-max-m-' + sid);

    function updateFill(f, lo, hi, max) {
      if (!f) return;
      f.style.left  = (lo / max * 100) + '%';
      f.style.width = ((hi - lo) / max * 100) + '%';
    }

    function syncSlidersToState() {
      if (rangeMin)    rangeMin.value    = priceMin;
      if (rangeMax_el) rangeMax_el.value = priceMax;
      if (inputMin)    inputMin.value    = priceMin;
      if (inputMax)    inputMax.value    = priceMax;
      updateFill(fill, priceMin, priceMax, RANGE_MAX);
      if (rMinM) rMinM.value = priceMin;
      if (rMaxM) rMaxM.value = priceMax;
      if (iMinM) iMinM.value = priceMin;
      if (iMaxM) iMaxM.value = priceMax;
      updateFill(fillM, priceMin, priceMax, RANGE_MAX);
    }

    if (rangeMin && rangeMax_el) {
      syncSlidersToState();

      function onSliderChange() {
        var lo = parseInt(rangeMin.value, 10);
        var hi = parseInt(rangeMax_el.value, 10);
        if (lo > hi) { var t = lo; lo = hi; hi = t; }
        if (inputMin)    inputMin.value    = lo;
        if (inputMax)    inputMax.value    = hi;
        updateFill(fill, lo, hi, RANGE_MAX);
        syncMobileToDesktop(lo, hi);
      }

      function onSliderRelease() {
        var lo = parseInt(rangeMin.value, 10);
        var hi = parseInt(rangeMax_el.value, 10);
        if (lo > hi) { var t = lo; lo = hi; hi = t; }
        priceMin = lo;
        priceMax = hi;
        history.pushState({}, '', buildUrl({}));
        applyPriceFilter();
      }

      rangeMin.addEventListener('input',     onSliderChange);
      rangeMax_el.addEventListener('input',  onSliderChange);
      rangeMin.addEventListener('change',    onSliderRelease);
      rangeMax_el.addEventListener('change', onSliderRelease);
      rangeMin.addEventListener('mouseup',   onSliderRelease);
      rangeMax_el.addEventListener('mouseup', onSliderRelease);
      rangeMin.addEventListener('touchend',  onSliderRelease);
      rangeMax_el.addEventListener('touchend', onSliderRelease);

      if (inputMin) {
        inputMin.addEventListener('change', function () {
          var lo = Math.max(0, Math.min(RANGE_MAX, parseInt(this.value, 10) || 0));
          var hi = Math.max(lo, priceMax);
          priceMin = lo;
          priceMax = hi;
          syncSlidersToState();
          history.pushState({}, '', buildUrl({}));
          applyPriceFilter();
        });
      }
      if (inputMax) {
        inputMax.addEventListener('change', function () {
          var hi = Math.max(0, Math.min(RANGE_MAX, parseInt(this.value, 10) || RANGE_MAX));
          var lo = Math.min(hi, priceMin);
          priceMin = lo;
          priceMax = hi;
          syncSlidersToState();
          history.pushState({}, '', buildUrl({}));
          applyPriceFilter();
        });
      }
    }

    /* Price dropdown open/close */
    if (priceTrigger && priceDrop) {
      priceTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        priceDrop.classList.toggle('open');
        priceTrigger.setAttribute('aria-expanded', priceDrop.classList.contains('open'));
      });
      document.addEventListener('click', function (e) {
        if (!priceDrop.contains(e.target)) {
          priceDrop.classList.remove('open');
          priceTrigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    /* ── Sort dropdown (desktop) ── */
    var sortDrop    = document.getElementById('sort-dropdown-' + sid);
    var sortTrigger = document.getElementById('sort-trigger-' + sid);
    var sortTrigVal = document.getElementById('sort-trigger-value-' + sid);
    var sortOptions = sortDrop ? sortDrop.querySelectorAll('[data-sort]') : [];

    /* Mobile sort bar (declared early so updateSortLabel can reference sortOptsM) */
    var sortDropM = document.getElementById('sort-dropdown-m-' + sid);
    var sortTrigM = document.getElementById('sort-trigger-m-' + sid);
    var sortOptsM = sortDropM ? sortDropM.querySelectorAll('[data-sort-m]') : [];

    function updateSortLabel() {
      var label = SORT_LABELS[activeSortVal] || 'Popularity';
      if (sortTrigVal) sortTrigVal.textContent = label;
      var mTrigVal = document.getElementById('sort-trigger-value-m-' + sid);
      if (mTrigVal) mTrigVal.textContent = label;
      sortOptions.forEach(function (opt) {
        opt.classList.toggle('selected', opt.dataset.sort === activeSortVal);
      });
      sortOptsM.forEach(function (opt) {
        opt.classList.toggle('selected', opt.dataset.sortM === activeSortVal);
      });
    }

    if (sortTrigger && sortDrop) {
      sortTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        sortDrop.classList.toggle('open');
        sortTrigger.setAttribute('aria-expanded', sortDrop.classList.contains('open'));
      });
      document.addEventListener('click', function (e) {
        if (!sortDrop.contains(e.target)) {
          sortDrop.classList.remove('open');
          sortTrigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    sortOptions.forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (sortDrop) sortDrop.classList.remove('open');
        applyFilters(buildUrl({ sortVal: opt.dataset.sort }), { sortVal: opt.dataset.sort });
      });
    });

    /* ── Stock toggles (desktop) ── */
    var stockContainer = document.getElementById('stock-toggles-' + sid);
    var stockBtns      = stockContainer ? stockContainer.querySelectorAll('.stock-btn') : [];

    /* Sheet stock refs (declared early so updateStockBtns can reference them) */
    var sheetFilter    = document.getElementById('sheet-filter-' + sid);
    var sheetStockBtns = sheetFilter ? sheetFilter.querySelectorAll('.sheet-stock-btn') : [];

    function updateStockBtns() {
      stockBtns.forEach(function (btn) {
        btn.classList.toggle('active', btn.dataset.stock === activeStock);
      });
      sheetStockBtns.forEach(function (btn) {
        btn.classList.toggle('active', btn.dataset.sheetStock === activeStock);
      });
    }

    stockBtns.forEach(function (btn) {
      btn.classList.toggle('active', btn.dataset.stock === activeStock);
      btn.addEventListener('click', function () {
        applyFilters(buildUrl({ stock: btn.dataset.stock }), { stock: btn.dataset.stock });
      });
    });

    /* ── Column toggle (client-side) ── */
    var viewBtns = wrapper.querySelectorAll('.view-btn');
    viewBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        viewBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (grid) {
          grid.classList.remove('cols-2', 'cols-3', 'cols-4');
          grid.classList.add('cols-' + btn.dataset.cols);
        }
      });
    });

    /* ── Mobile filter bottom sheet ── */
    var backdrop        = document.getElementById('sheet-backdrop-' + sid);
    var mobileFilterBtn = document.getElementById('mobile-filter-btn-' + sid);
    var sheetClose      = document.getElementById('sheet-filter-close-' + sid);

    function openSheet() {
      if (backdrop)    backdrop.classList.add('open');
      if (sheetFilter) sheetFilter.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeSheets() {
      if (backdrop)    backdrop.classList.remove('open');
      if (sheetFilter) sheetFilter.classList.remove('open');
      document.body.style.overflow = '';
    }
    if (mobileFilterBtn) mobileFilterBtn.addEventListener('click', openSheet);
    if (backdrop)        backdrop.addEventListener('click', closeSheets);
    if (sheetClose)      sheetClose.addEventListener('click', closeSheets);

    /* ── Mobile price slider (sheet) ── */
    function syncMobileToDesktop(lo, hi) {
      if (rMinM) rMinM.value = lo;
      if (rMaxM) rMaxM.value = hi;
      if (iMinM) iMinM.value = lo;
      if (iMaxM) iMaxM.value = hi;
      updateFill(fillM, lo, hi, RANGE_MAX);
    }

    if (rMinM) {
      updateFill(fillM, priceMin, priceMax, RANGE_MAX);
      rMinM.value = priceMin;
      if (rMaxM) rMaxM.value = priceMax;
      if (iMinM) iMinM.value = priceMin;
      if (iMaxM) iMaxM.value = priceMax;

      function onMobileSliderChange() {
        var lo = parseInt(rMinM.value, 10);
        var hi = parseInt(rMaxM ? rMaxM.value : RANGE_MAX, 10);
        if (lo > hi) { var t = lo; lo = hi; hi = t; }
        if (iMinM) iMinM.value = lo;
        if (iMaxM) iMaxM.value = hi;
        updateFill(fillM, lo, hi, RANGE_MAX);
        if (rangeMin)    rangeMin.value    = lo;
        if (rangeMax_el) rangeMax_el.value = hi;
        if (inputMin)    inputMin.value    = lo;
        if (inputMax)    inputMax.value    = hi;
        updateFill(fill, lo, hi, RANGE_MAX);
      }

      function onMobileSliderRelease() {
        var lo = parseInt(rMinM.value, 10);
        var hi = parseInt(rMaxM ? rMaxM.value : RANGE_MAX, 10);
        if (lo > hi) { var t = lo; lo = hi; hi = t; }
        priceMin = lo;
        priceMax = hi;
        closeSheets();
        history.pushState({}, '', buildUrl({}));
        applyPriceFilter();
      }

      rMinM.addEventListener('input',    onMobileSliderChange);
      if (rMaxM) rMaxM.addEventListener('input', onMobileSliderChange);
      rMinM.addEventListener('change',   onMobileSliderRelease);
      if (rMaxM) rMaxM.addEventListener('change', onMobileSliderRelease);
      rMinM.addEventListener('mouseup',  onMobileSliderRelease);
      if (rMaxM) rMaxM.addEventListener('mouseup', onMobileSliderRelease);
      rMinM.addEventListener('touchend', onMobileSliderRelease);
      if (rMaxM) rMaxM.addEventListener('touchend', onMobileSliderRelease);

      if (iMinM) {
        iMinM.addEventListener('change', function () {
          priceMin = Math.max(0, Math.min(RANGE_MAX, parseInt(this.value, 10) || 0));
          closeSheets();
          syncSlidersToState();
          history.pushState({}, '', buildUrl({}));
          applyPriceFilter();
        });
      }
      if (iMaxM) {
        iMaxM.addEventListener('change', function () {
          priceMax = Math.max(0, Math.min(RANGE_MAX, parseInt(this.value, 10) || RANGE_MAX));
          closeSheets();
          syncSlidersToState();
          history.pushState({}, '', buildUrl({}));
          applyPriceFilter();
        });
      }
    }

    /* ── Sheet stock toggles ── */
    sheetStockBtns.forEach(function (btn) {
      btn.classList.toggle('active', btn.dataset.sheetStock === activeStock);
      btn.addEventListener('click', function () {
        closeSheets();
        applyFilters(buildUrl({ stock: btn.dataset.sheetStock }), { stock: btn.dataset.sheetStock });
      });
    });

    /* ── Sheet sort options ── */
    var sheetSortOpts = sheetFilter ? sheetFilter.querySelectorAll('[data-sort-s]') : [];
    sheetSortOpts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        closeSheets();
        applyFilters(buildUrl({ sortVal: opt.dataset.sortS }), { sortVal: opt.dataset.sortS });
      });
    });

    /* ── Mobile sort bar ── */
    if (sortTrigM && sortDropM) {
      sortTrigM.addEventListener('click', function (e) {
        e.stopPropagation();
        sortDropM.classList.toggle('open');
        sortTrigM.setAttribute('aria-expanded', sortDropM.classList.contains('open'));
      });
      document.addEventListener('click', function (e) {
        if (sortDropM && !sortDropM.contains(e.target)) {
          sortDropM.classList.remove('open');
          sortTrigM.setAttribute('aria-expanded', 'false');
        }
      });
    }

    sortOptsM.forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (sortDropM) sortDropM.classList.remove('open');
        applyFilters(buildUrl({ sortVal: opt.dataset.sortM }), { sortVal: opt.dataset.sortM });
      });
    });

    /* ── Load more ── */
    var loadMoreBtn   = document.getElementById('load-more-btn-' + sid);
    var loadMoreCount = document.getElementById('load-more-count-' + sid);

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        var nextUrl = loadMoreBtn.dataset.nextUrl;
        if (!nextUrl) return;

        /* Read counts at click-time so they stay correct after filter changes */
        var shownNow = parseInt(loadMoreBtn.dataset.shown, 10) || 0;
        var totalNow = parseInt(loadMoreBtn.dataset.total,  10) || 0;

        loadMoreBtn.classList.add('loading');
        loadMoreBtn.disabled = true;

        fetch(nextUrl + '&section_id=' + sid, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var doc      = new DOMParser().parseFromString(html, 'text/html');
            var newGrid  = doc.getElementById('product-grid-' + sid);
            var newLMBtn = doc.getElementById('load-more-btn-' + sid);

            if (newGrid && grid) {
              /* Select only .product-card direct children — skip any .no-results div */
              var newCards = Array.from(newGrid.querySelectorAll(':scope > .product-card'));
              if (newCards.length) {
                /* insertAdjacentHTML appends HTML text into the existing grid,
                   creating fresh document-owned nodes without cross-doc adoption issues. */
                var newHtml = newCards.map(function (c) { return c.outerHTML; }).join('');
                grid.insertAdjacentHTML('beforeend', newHtml);
                shownNow += newCards.length;
                /* Keep data-shown in sync so the next click reads the correct base */
                loadMoreBtn.dataset.shown = shownNow;
              }
            }

            if (newLMBtn && newLMBtn.dataset.nextUrl) {
              loadMoreBtn.dataset.nextUrl = newLMBtn.dataset.nextUrl;
              if (loadMoreCount) {
                loadMoreCount.textContent = 'Showing ' + shownNow + ' of ' + totalNow + ' products';
              }
            } else {
              if (loadMoreWrap) loadMoreWrap.classList.add('hidden');
            }

            /* Apply price filter to the newly appended cards */
            applyPriceFilter();
          })
          .catch(function (err) {
            console.error('[TOV] Load more failed:', err);
          })
          .finally(function () {
            loadMoreBtn.classList.remove('loading');
            loadMoreBtn.disabled = false;
          });
      });
    }

    /* ── Init ── */
    checkFilterActive();
    renderActiveFilters();
    /* Apply price filter on page load in case URL params are present */
    if (priceMin > 0 || priceMax < RANGE_MAX) {
      applyPriceFilter();
    }

  }); /* end forEach .collection-page */

})();
